<ng-container *ngIf="!initComplete; else content">
    <div class="container">
        <div class="hero progress"></div>
        <div class="column is-two-thirds">
            <div class="box" style="padding-bottom: 0">
                <div class="tile heading is-child notification" style="padding-top: 0;padding-bottom: 0">
                    <div class="title is-3 is-darkblue"></div>
                </div>
                <div class="tile is-child notification" style="padding-right: 0; padding-top: 0">
                    <div class="card">
                        <hr>
                        <div class="columns">
                            <div class="column is-one-third">
                            </div>
                            <div class="column is-two-thirds">
                                <div class="orderProduct">
                                    <div class="title is-darkblue is-5">
                                        <u>
                                            <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                  appearance="line" count="1">
                                            </ngx-skeleton-loader>
                                        </u>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-darkblue">
                                            <div>
                                                <div class="columns">
                                                    <div class="column">
                                                        <div class="title is-darkblue is-6">
                                                            <u>
                                                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                                      appearance="line" count="1">
                                                                </ngx-skeleton-loader>
                                                            </u>
                                                        </div>
                                                    </div>
                                                    <div class="column is-2 left is-darkblue">
                                                        <div class="title is-6 is-pulled-right" style="white-space: nowrap">
                                                            <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                                  appearance="line" count="1">
                                                            </ngx-skeleton-loader>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <div class="columns">
                                                    <div class="column">
                                                        <div class="title is-darkblue is-6">
                                                            <u>
                                                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                                      appearance="line" count="1">
                                                                </ngx-skeleton-loader>
                                                            </u>
                                                        </div>
                                                    </div>
                                                    <div class="column is-2 left is-darkblue">
                                                        <div class="title is-6 is-pulled-right" style="white-space: nowrap">
                                                            <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                                  appearance="line" count="1">
                                                            </ngx-skeleton-loader>
                                                        </div>
                                                    </div>
                                                </div>

                                                <ng-container *ngFor="let _ of [].constructor(5)">
                                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                                          appearance="line" count="1">
                                                    </ngx-skeleton-loader>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns is-darkblue mt-6">
                            <div class="column is-one-third">
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                            </div>
                            <div class="column">
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                            </div>
                            <div class="column is-one-quarter"></div>
                        </div>
                        <div *ngIf="initComplete" class="columns is-darkblue">
                            <div class="column is-one-third">
                                <p>
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                                <p class="is-clickable" style="color: #d0d7db">
                                <p>
                                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                          appearance="line" count="1">
                                    </ngx-skeleton-loader>
                                </p>
                            </div>
                            <div class="column is-one-quarter"></div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                      appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #content>
    <div class="container">
        <div class="hero progress"></div>
        <div class="columns">
            <div class="column is-two-thirds">
                <form [formGroup]="additionalOrderInformationForm">
                    <div class="box mb-5">
                        <div class="columns">
                            <div class="column is-half">
                                <div class="title is-4 is-darkblue is-inline-block">
                                  Kundenreferenz
                                  <span *ngIf="additionalOrderInformationForm && additionalOrderInformationForm.value.customOrderName" class="additional-text-information does-not-wrap"
                                        [ngClass]="{'required':additionalOrderInformationForm.value.customOrderName.length > maxReferenceInput}">
                                        {{additionalOrderInformationForm.value.customOrderName.length + ' / ' + maxReferenceInput + ' Zeichen'}}
                                    </span>
                                </div>
                                <div class="columns">
                                    <div class="column">
                                        <input class="w-100 line-height-is-2" type="text" placeholder="Geben Sie Ihrer Bestellung eine für Sie passende Referenz (optional)" formControlName="customOrderName"
                                               [ngClass]="{'has-error': hasError(additionalOrderInformationForm.get('customOrderName'))}">
                                    </div>
                                </div>
                            </div>
                            <div class="column is-half">
                                <div class="title is-4 is-darkblue is-inline-block">
                                    Zusätzliche Infos
                                    <span *ngIf="additionalOrderInformationForm && additionalOrderInformationForm.value.additionalInformation" class="additional-text-information does-not-wrap"
                                          [ngClass]="{'required':additionalOrderInformationForm.value.additionalInformation.length > maxInformationInput}">
                                        {{additionalOrderInformationForm.value.additionalInformation.length + ' / ' + maxInformationInput + ' Zeichen'}}
                                    </span>
                                </div>
                                <div class="columns">
                                    <div class="column">
                                        <div class="text-area-container p-2 is-flex is-justify-content-center is-align-items-center has-border border-rounded mb-3"
                                             [ngClass]="{'has-error': hasError(additionalOrderInformationForm.get('additionalInformation'))}">
                                            <textarea cdkTextareaAutosize
                                              cdkAutosizeMinRows="1"
                                              cdkAutosizeMaxRows="7"
                                              formControlName="additionalInformation"
                                              placeholder="Um zusätzliche Infos anzugeben tippen Sie hier..." class="w-100 no-border"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="box" style="padding-bottom: 0">
                    <div class="tile heading is-child notification" style="padding-top: 0;padding-bottom: 0; padding-left: 0;">
                        <div class="title is-4 is-darkblue" *ngIf="properties.length > 1">Warenkorb
                            ({{properties.length}} Objekte)
                        </div>
                        <div class="title is-4 is-darkblue" *ngIf="properties.length == 1">Warenkorb
                            ({{properties.length}} Objekt)
                        </div>
                    </div>
                    <div id="property-list" class="tile is-child notification" style="padding-right: 0; padding-top: 0; padding-left: 0;">
                        <div class="card" *ngFor="let property of properties">
                            <hr>
                            <div class="columns">
                                <div class="column is-one-third">
                                </div>
                                <div class="column is-two-thirds">
                                    <div class="orderProduct">
                                        <div class="title is-darkblue is-6 mb-3"><u>{{property.town}}, {{property.street}}</u></div>

                                        <p class="mb-5 mt-5" *ngIf="getRelevantProductValueProductsForProperty(property).length > 0">Zu ihren bestellten Dokumenten zusätzlich gemachte Angaben:</p>
                                        <ng-container *ngFor="let product of getRelevantProductValueProductsForProperty(property)">
                                          <div class="columns" *ngFor="let productValue of getFilteredProductValues(product, property)">
                                            <div class="column pb-0">
                                              <p>
                                                <span class="is-darkblue">{{productValue.name}}:</span>
                                                {{property.additionalProductValues[productValue.key]}}
                                              </p>
                                            </div>
                                          </div>
                                        </ng-container>

                                        <p *ngIf="getRelevantProductValueProductsForProperty(property).length > 0" class="color-dark-gray is-clickable has-text-right mb-3 is-underlined" (click)="openProductValueDialogForProperty(property)">Angaben bearbeiten</p>

                                        <div class="columns is-justify-content-end">
                                            <div class="column is-darkblue">
                                                <ng-container *ngIf="categorizedDocumentsList && categorizedDocumentsList[property.id]">
                                                    <!--documents that are part of an explicit document package are listed here if the platformType is "STEUER"-->
                                                    <div *ngIf="categorizedDocumentsList[property.id].packageGroups.length > 0 && platformProfile">
                                                        <ng-container *ngFor="let group of categorizedDocumentsList[property.id].packageGroups">
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <div class="title is-darkblue is-6"><u>{{getPackageTitleForGroup(group.package)}}</u></div>
                                                                </div>
                                                                <div class="column is-2 left is-darkblue">
                                                                    <div class="title is-6 is-pulled-right" style="white-space: nowrap">{{getPackagePriceForProperty(property, group.package) | currency: 'EUR'}}</div>
                                                                </div>
                                                            </div>
                                                            <ng-container *ngFor="let document of group.documents">
                                                                <ng-container [ngTemplateOutlet]="documentTemplate" [ngTemplateOutletContext]="{document: document, property: property}"></ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>

                                                    <!--documents with regular pricing are listed here-->
                                                    <div *ngIf="categorizedDocumentsList[property.id].regularPricingDocs.length > 0">
                                                        <div class="columns mt-4">
                                                            <div class="column">
                                                                <div class="title is-darkblue is-6"><u>Auskünfte</u></div>
                                                            </div>
                                                            <div class="column is-2 left is-darkblue">
                                                                <div class="title is-6 is-pulled-right" style="white-space: nowrap">{{getPriceForPropertyDocuments(property) | currency: 'EUR'}}</div>
                                                            </div>
                                                        </div>

                                                        <ng-container *ngFor="let document of categorizedDocumentsList[property.id].regularPricingDocs">
                                                            <ng-container [ngTemplateOutlet]="documentTemplate" [ngTemplateOutletContext]="{document: document, property: property}"></ng-container>
                                                        </ng-container>
                                                    </div>

                                                    <!--documents that have pricing on request are listed here-->
                                                    <div *ngIf="categorizedDocumentsList[property.id].pricingOnRequestDocs.length > 0">
                                                        <div class="columns">
                                                            <div class="column">
                                                                <div class="title is-darkblue is-6"><u>Preise auf Anfrage</u></div>
                                                            </div>
                                                            <div class="column is-2 left is-darkblue">
                                                                <div class="title is-6 is-pulled-right" style="white-space: nowrap">Wir kontaktieren Sie.</div>
                                                            </div>
                                                        </div>


                                                        <ng-container *ngFor="let document of categorizedDocumentsList[property.id].pricingOnRequestDocs">
                                                            <ng-container [ngTemplateOutlet]="documentTemplate" [ngTemplateOutletContext]="{document: document, property: property}"></ng-container>
                                                        </ng-container>
                                                    </div>

                                                  <div *ngIf="categorizedDocumentsList[property.id].premiumServiceDocs.length > 0 && premiumServiceDocumentOrderLines">
                                                    <ng-container *ngFor="let categoryGroup of premiumServiceDocumentGroups[property.id]">
                                                      <div class="columns">
                                                        <div class="column">
                                                          <div class="title is-darkblue is-6">
                                                            <u>{{ categoryGroup.category }}</u>
                                                          </div>
                                                        </div>
                                                        <div class="column is-2 left is-darkblue">
                                                          <div class="title is-6 is-pulled-right does-not-wrap">
                                                            {{ categoryGroup.totalPrice | currency: 'EUR' }}
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <ng-container *ngFor="let document of categoryGroup.documents">
                                                        <ng-container
                                                            [ngTemplateOutlet]="documentTemplate"
                                                            [ngTemplateOutletContext]="{document: document, property: property}">
                                                        </ng-container>
                                                      </ng-container>
                                                    </ng-container>
                                                  </div>
                                                </ng-container>
                                                <div *ngIf="property.dataResearch">
                                                    <div class="columns">
                                                        <div class="column">
                                                            <div class="title is-6"><u>Grundstücksdatenrecherche</u></div>
                                                        </div>
                                                        <div class="column is-2 has-text-left is-darkblue">
                                                            <div class="title is-6 is-pulled-right" style="white-space: nowrap">
                                                                {{getPriceForPropertyDataResearch(property) | currency: 'EUR'}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--documents credited by the pricing engine, e.g. a Baulast that cannot be delivered in Bavaria-->
                                                <div *ngIf="getCancellationsForProperty(property).length > 0">
                                                    <div class="columns">
                                                        <div class="column">
                                                            <div class="title is-darkblue is-6 is-flex is-align-items-center">
                                                                <u>Storno</u>
                                                                <img *ngIf="hasBaulasCancellation(property)" class="ml-2" width="15" height="15"
                                                                     src="assets/images/InfoIcon/info_icon.svg" alt="Info Icon"
                                                                     matTooltip="Im Bundesland Bayern wird kein Baulastenverzeichnis geführt, daher können wir Ihnen auch keine Auskunft erteilen. Sollten Baulasten vorhanden sein, sind diese im Grundbuch in Abteilung II eingetragen."
                                                                     matTooltipPosition="above"/>
                                                            </div>
                                                        </div>
                                                        <div class="column is-2 left is-darkblue">
                                                            <div class="title is-6 is-pulled-right" style="white-space: nowrap">{{getCancellationSumForProperty(property) | currency: 'EUR'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="columns" style="margin-bottom: 0.75rem !important;" *ngFor="let cancellation of getCancellationsForProperty(property)">
                                                        <div class="column is-10" style="padding-top: 0; padding-bottom: 0">
                                                            <div class="truncate" [matTooltip]="cancellation.label" appTooltip>{{cancellation.label}}</div>
                                                        </div>
                                                        <div class="column is-2" style="padding-top: 0; padding-bottom: 0">
                                                            <div class="is-pulled-right" style="white-space: nowrap">{{cancellation.amount | currency: 'EUR'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="initComplete" class="columns is-darkblue mt-6">
                                <div class="column is-one-third">
                                    <p>Rechnungsempfänger</p>
                                    <p class="is-clickable" style="color: #d0d7db" (click)="openDialog(property)">ändern</p>
                                </div>
                                <div *ngIf="property.billingAdress" class="column">
                                    <p *ngIf="property.billingAdress.name">{{property.billingAdress.name}}</p>
                                    <p>{{property.billingAdress.firma}}</p>
                                    <p>{{property.billingAdress.street}}</p>
                                    <p>{{property.billingAdress.plz}} {{property.billingAdress.town}}</p>
                                </div>
                                <div class="column is-one-quarter"></div>
                            </div>
                            <div *ngIf="initComplete" class="columns is-darkblue">
                                <div class="column is-one-third">
                                    <p>Leistungsempfänger</p>
                                    <p class="is-clickable" style="color: #d0d7db" (click)="openDialog(property)">ändern</p>
                                </div>
                                <div class="column">
                                    <div *ngIf="billingAdressEqualsBeneficiaryAdress(property);else benificiaryFormValue">
                                      entspricht dem Rechnungempfänger
                                    </div>
                                    <ng-template #benificiaryFormValue>
                                        <div *ngIf="property.beneficiaryAddress">
                                            <p *ngIf="property.beneficiaryAddress.name">{{property.beneficiaryAddress.name}}</p>
                                            <p>{{property.beneficiaryAddress.firma}}</p>
                                            <p>{{property.beneficiaryAddress.street}}</p>
                                            <p>{{property.beneficiaryAddress.plz}} {{property.beneficiaryAddress.town}}</p>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="column is-one-quarter"></div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                </div>
                                <div class="column">
                                    <a class="is-pulled-right" (click)="removePropertyFromCart(property)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="19" viewBox="0 0 60 19">
                                            <text id="Entfernen" transform="translate(0 15)" fill="#d0d7db"
                                                  font-size="14" font-family="SegoeUI, Segoe UI">
                                                <tspan x="0" y="0">Objekt Entfernen</tspan>
                                            </text>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.693" height="18.084"
                                             viewBox="0 0 14.693 18.084">
                                            <path id="Icon_metro-bin" data-name="Icon metro-bin"
                                                  d="M5.629,7.579v11.3a1.134,1.134,0,0,0,1.13,1.13H16.932a1.134,1.134,0,0,0,1.13-1.13V7.579H5.629ZM9.02,17.752H7.89V9.84H9.02Zm2.261,0H10.15V9.84h1.13Zm2.261,0h-1.13V9.84h1.13Zm2.261,0h-1.13V9.84H15.8ZM18.344,4.189H14.671V2.776a.85.85,0,0,0-.848-.848H9.867a.85.85,0,0,0-.848.848V4.189H5.346a.85.85,0,0,0-.848.848V6.449H19.192V5.036a.85.85,0,0,0-.848-.848Zm-4.8,0H10.15V3.072h3.391V4.189Z"
                                                  transform="translate(-4.499 -1.928)" fill="#d0d7db"></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-one-third">
                <div class="box">
                    <div class="title is-4 is-darkblue">Benachrichtigungen</div>
                    <div class="content">
                        <blockquote>Hinterlegen Sie hier alle E-Mail-Adressen, die Benachrichtigungen erhalten sollen.</blockquote>
                        <div *ngFor="let email of contactList">
                            <div class="columns mb-1">
                              <div class="column is-10 email-container">
                                <span class="">{{email}}</span>
                              </div>
                              <div class="column is-2 is-flex is-align-items-center is-justify-content-center">
                                <svg *ngIf="!hideDeleteButtonForCurrentUserMail(email)" (click)="removeMailFromContactList(email)" class="is-clickable" xmlns="http://www.w3.org/2000/svg" width="19.25" height="19.25" viewBox="0 0 29.25 29.25">
                                  <g id="Icon_ionic-ios-close-circle-outline"
                                     data-name="Icon ionic-ios-close-circle-outline"
                                     transform="translate(-3.375 -3.375)"
                                  >
                                    <path id="Pfad_17" data-name="Pfad 17"
                                          d="M23.295,21.705,19.589,18l3.705-3.705a1.124,1.124,0,0,0-1.589-1.589L18,16.411l-3.705-3.705a1.124,1.124,0,0,0-1.589,1.589L16.411,18l-3.705,3.705a1.086,1.086,0,0,0,0,1.589,1.116,1.116,0,0,0,1.589,0L18,19.589l3.705,3.705a1.129,1.129,0,0,0,1.589,0A1.116,1.116,0,0,0,23.295,21.705Z"
                                          fill="#f14668">
                                    </path>
                                    <path id="Pfad_18" data-name="Pfad 18"
                                          d="M18,5.344A12.651,12.651,0,1,1,9.049,9.049,12.573,12.573,0,0,1,18,5.344m0-1.969A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z"
                                          fill="#f14668">
                                    </path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                        </div>
                        <form [formGroup]="contactListForm">
                            <div class="mail-base">
                                <input class="input-mail" type="text" placeholder="weitere hinzufügen (optional)" (keyup.enter)="addEmailToContactList()" formControlName="email">
                                <div class="input-icon-base is-clickable" (click)="addEmailToContactList()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
                                        <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                                              d="M26.929,13.643H17.607V4.321A2.072,2.072,0,0,0,15.536,2.25H13.464a2.072,2.072,0,0,0-2.071,2.071v9.321H2.071A2.072,2.072,0,0,0,0,15.714v2.071a2.072,2.072,0,0,0,2.071,2.071h9.321v9.321a2.072,2.072,0,0,0,2.071,2.071h2.071a2.072,2.072,0,0,0,2.071-2.071V19.857h9.321A2.072,2.072,0,0,0,29,17.786V15.714A2.072,2.072,0,0,0,26.929,13.643Z"
                                              transform="translate(0 -2.25)" fill="#21A420">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                            <app-notification *ngIf="errorMsg" [content]="this.errorMsg" (notificationClosed)="this.errorMsg=null" timeOut="0" display="true" error=true></app-notification>
                        </form>
                    </div>
                </div>

                <div class="box">
                    <div class="title is-4 is-darkblue">Gesamtsumme</div>
                    <div class="columns is-darkblue">
                        <div class="column is-three-fifths">
                            <ul>
                                <li>Zwischensumme</li>
                            </ul>
                        </div>
                        <div class="column is-one-fifth">
                        </div>
                        <div class="column is-one-fifth">
                            <ul class="is-pulled-right">
                                <li>{{propertySum | currency: 'EUR'}}</li>
                            </ul>
                        </div>
                    </div>
                    <hr>
                    <div class="columns is-darkblue">
                        <div class="column is-three-quarters">
                            <ul>
                                <li>Gesamtsumme</li>
                                <li [matTooltip]="'zzgl. Behördenauslagen'" appTooltip class="truncate">zzgl. Behördenauslagen</li>
                                <ng-container *ngIf="hasAnyPropertyBauakte()">
                                    <li [matTooltip]="'zzgl. Behördenbesuch'" appTooltip class="truncate">zzgl. Behördenbesuch</li>
                                    <ng-container *ngIf="bookedAdditionalBauaktenServices">
                                        <li matTooltip="{{'zzgl.' + getServiceLongName(bookableServicesByCategory, additionalServiceShortName)}}"
                                            appTooltip class="truncate"
                                            *ngFor="let additionalServiceShortName of bookedAdditionalBauaktenServices">
                                            zzgl. {{getServiceLongName(bookableServicesByCategory, additionalServiceShortName)}}</li>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="hasAnyPropertyBewil() && bewilCertificatePrice > 0">
                                  <li matTooltip="zzgl. {{bewilCertificatePrice}}€ pro Urkunde" appTooltip class="truncate">zzgl. {{bewilCertificatePrice}}€ pro Urkunde</li>
                                </ng-container>
                            </ul>
                        </div>
                        <div class="column is-one-quarter">
                            <ul class="is-pulled-right">
                                <li>{{propertySum | currency: 'EUR'}}</li>
                                <li class="has-text-right">1:1</li>
                                <ng-container *ngIf="hasAnyPropertyBauakte()">
                                    <li class="has-text-right" *ngIf="hasAnyPropertyBauakte()">{{bauakPricePerHour}}€/h</li>
                                    <ng-container *ngIf="bookedAdditionalBauaktenServices">
                                        <li class="has-text-right"
                                            *ngFor="let _ of bookedAdditionalBauaktenServices">{{bauakPricePerHour}}€/h
                                        </li>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                    <p style="color: #d0d7db; font-size: 12px; text-align: center; margin-bottom: 10px">Alle Preise verstehen sich netto zzgl. gesetzlicher Mehrwertsteuer</p>

                    <p *ngIf="platformProfile.generalAgreements && platformProfile.generalAgreements.length > 0 else agbText" class="has-text-centered mb-2 is-size-7">
                      Es gelten die Bestimmungen aus dem Rahmenvertrag.
                    </p>

                    <ng-template #agbText>
                      <p class="has-text-centered mb-2 is-size-7">
                        Mit Klick auf <span class="is-bold">Verbindlich bestellen</span>
                        erklären Sie sich mit unseren
                        <a href="https://www.docestate.com/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a>
                        einverstanden und bestätigen die Kenntnisnahme von unseren
                        <a href="https://www.docestate.com/datenschutzerklaerung/" target="_blank">Datenschutzbestimmungen</a>
                      </p>
                    </ng-template>

                    <div class="columns is-centered">
                        <div class="column">
                            <button class="button is-green" [ngClass]="{'is-loading': startedOrderProcess}" [disabled]="startedOrderProcess || contactList.length === 0 || pricingUnavailable" (click)="setOrder()">Verbindlich bestellen</button>
                        </div>
                    </div>
                  <div class="columns">
                    <div class="column">
                      <app-notification *ngIf="showOrderError" [content]="'Fehler beim Anlegen der Bestellung! Versuchen Sie es später erneut.'" timeOut="5000" display="true" (notificationClosed)="showOrderError = false" [error]="true"></app-notification>
                      <app-notification *ngIf="pricingUnavailable" [content]="'Die Preise konnten nicht ermittelt werden. Eine Bestellung ist derzeit nicht möglich, bitte versuchen Sie es später erneut.'" timeOut="0" display="true" [error]="true"></app-notification>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #removeIconTemplate let-property="property" let-document="document">
    <div class="column is-2 has-text-right" style="padding-top: 0; padding-bottom: 0;">
        <a (click)="removeDocumentFromProperty(property,document)">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.25" height="19.25" viewBox="0 0 29.25 29.25">
                <g id="Icon_ionic-ios-close-circle-outline"
                   data-name="Icon ionic-ios-close-circle-outline"
                   transform="translate(-3.375 -3.375)">
                    <path id="Pfad_17" data-name="Pfad 17"
                          d="M23.295,21.705,19.589,18l3.705-3.705a1.124,1.124,0,0,0-1.589-1.589L18,16.411l-3.705-3.705a1.124,1.124,0,0,0-1.589,1.589L16.411,18l-3.705,3.705a1.086,1.086,0,0,0,0,1.589,1.116,1.116,0,0,0,1.589,0L18,19.589l3.705,3.705a1.129,1.129,0,0,0,1.589,0A1.116,1.116,0,0,0,23.295,21.705Z"
                          fill="#d0d7db"></path>
                    <path id="Pfad_18" data-name="Pfad 18"
                          d="M18,5.344A12.651,12.651,0,1,1,9.049,9.049,12.573,12.573,0,0,1,18,5.344m0-1.969A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z"
                          fill="#d0d7db"></path>
                </g>
            </svg>
        </a>
    </div>
</ng-template>

<ng-template #documentTemplate let-property="property" let-document="document">
    <div class="columns" style="margin-bottom: 0.75rem !important;">
        <div class="column is-10" style="padding-top: 0; padding-bottom: 0">
            <div *ngIf="document.docname != 'digitiz' && document.docname != 'leitung'" class="truncate" [matTooltip]="getFullName(document.docname)" appTooltip>{{getFullName(document.docname)}}</div>

            <div *ngIf="document.docname === 'digitiz'">
                <p>Sie erhalten von uns ein individuelles Angebot</p>
                <p class="color-gray is-size-7">Sie verursachen vorher noch keine Kosten</p>
            </div>

            <div *ngIf="isDocumentBauaktenDocument(document.docname)">
                <p class="color-gray is-size-7">Sofern ein Behördenbesuch erforderlich ist fallen zusätzlich Kosten in Höhe von {{bauakPricePerHour}}€ pro Stunde an.</p>
            </div>

            <div *ngIf="isDocumentGrundeDocument(document.docname) && !hasAnyPropertyBauakte() && !hasAnyPropertyBewil()">
              <p class="color-gray is-size-7">50% des Dokumentenpreises für zusätzliche Grundbuchblätter</p>
            </div>

            <div *ngIf="document.docname === 'bewilu' && bewilCertificatePrice > 0">
              <p class="color-gray is-size-7">Es fallen zusätzliche Kosten in Höhe von {{bewilCertificatePrice}}€ pro Urkunde an.</p>
            </div>

            <ng-container *ngIf="document.selectedServices.length > 0">
                <div class="title is-darkblue is-6 mt-2 mb-0 is-bold is-italic">Services:</div>
                <p *ngIf="!bookableServicesByCategory">
                    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px 0 2px 1.5rem','width':'85%'}" appearance="line"
                                         count="1"></ngx-skeleton-loader>
                </p>
                <ng-container *ngIf="bookableServicesByCategory">
                    <ul class="ml-5 bullet-list">
                        <li *ngFor="let service of document.selectedServices">
                            {{getServiceLongName(bookableServicesByCategory, service.nameShort)}}
                        </li>
                    </ul>
                </ng-container>
            </ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="removeIconTemplate" [ngTemplateOutletContext]="{property: property, document: document}"></ng-container>
    </div>
</ng-template>
